<div *ngFor="let element of elements; let i = index">
    <app-preview-element [actions]="actions" (action)="onActionClick($event)" [element]="element"></app-preview-element>
</div>
